module.exports = __webpack_public_path__ + "img/reutilizamos.a2cfa2f4.jpg";